import * as React from "react";
import styles from "./style.module.scss";

export const LoaderSmall: React.FC = () => <div className={styles.loaderSmall} />;
